
class lookBack extends HTMLElement {
    constructor() {
        super();

        /* Slider Initialization */
        let sliderParent = this.querySelector('.swiper-slider-custom');
        let sliderOptions = sliderParent.getAttribute('data-slider-custom');
        sliderOptions = JSON.parse(sliderOptions);
        this.swiper = new Swiper(sliderParent, sliderOptions);
    
        document.querySelectorAll('[data-look-back-btn]').forEach(button => button.addEventListener('click', this._changeSlide.bind(this)));
    }

    _changeSlide(event) {
        let getSlideIndex = event.currentTarget.getAttribute('data-look-back-btn');
        getSlideIndex = Number(getSlideIndex) - 1;
        this.swiper.slideTo(getSlideIndex);
    }
}

customElements.define('look-back-modal', lookBack);